var url_params = new URLSearchParams(window.location.search);
var dev_param = url_params.get('dev');



if ( typeof dev_param !== 'undefined' && dev_param == 'michelle' ) {

  (function () {
    
    let ap_store_map = {
      "CA": "https://ca.activationproducts.com/",
      "AS": "https://au.activationproducts.com/",
      "AU": "https://au.activationproducts.com/",
      "NZ": "https://au.activationproducts.com/",
      "CK": "https://au.activationproducts.com/",
      "TL": "https://au.activationproducts.com/",
      "FM": "https://au.activationproducts.com/",
      "FJ": "https://au.activationproducts.com/",
      "PF": "https://au.activationproducts.com/",
      "GU": "https://au.activationproducts.com/",
      "KI": "https://au.activationproducts.com/",
      "MP": "https://au.activationproducts.com/",
      "MH": "https://au.activationproducts.com/",
      "UM": "https://au.activationproducts.com/",
      "NR": "https://au.activationproducts.com/",
      "NC": "https://au.activationproducts.com/",
      "NZ": "https://au.activationproducts.com/",
      "NU": "https://au.activationproducts.com/",
      "NF": "https://au.activationproducts.com/",
      "PW": "https://au.activationproducts.com/",
      "PG": "https://au.activationproducts.com/",
      "MP": "https://au.activationproducts.com/",
      "WS": "https://au.activationproducts.com/",
      "SB": "https://au.activationproducts.com/",
      "TK": "https://au.activationproducts.com/",
      "TO": "https://au.activationproducts.com/",
      "TV": "https://au.activationproducts.com/",
      "VU": "https://au.activationproducts.com/",
      "UM": "https://au.activationproducts.com/",
      "WF": "https://au.activationproducts.com/",
      "AF": "https://au.activationproducts.com/",
      "AM": "https://au.activationproducts.com/",
      "AZ": "https://au.activationproducts.com/",
      "BH": "https://au.activationproducts.com/",
      "BD": "https://au.activationproducts.com/",
      "BT": "https://au.activationproducts.com/",
      "BN": "https://au.activationproducts.com/",
      "KH": "https://au.activationproducts.com/",
      "CN": "https://au.activationproducts.com/",
      "CX": "https://au.activationproducts.com/",
      "CC": "https://au.activationproducts.com/",
      "IO": "https://au.activationproducts.com/",
      "GE": "https://au.activationproducts.com/",
      "HK": "https://au.activationproducts.com/",
      "IN": "https://au.activationproducts.com/",
      "ID": "https://au.activationproducts.com/",
      "IR": "https://au.activationproducts.com/",
      "IQ": "https://au.activationproducts.com/",
      "IL": "https://au.activationproducts.com/",
      "JP": "https://au.activationproducts.com/",
      "JO": "https://au.activationproducts.com/",
      "KZ": "https://au.activationproducts.com/",
      "KW": "https://au.activationproducts.com/",
      "KG": "https://au.activationproducts.com/",
      "LA": "https://au.activationproducts.com/",
      "LB": "https://au.activationproducts.com/",
      "MO": "https://au.activationproducts.com/",
      "MY": "https://au.activationproducts.com/",
      "MV": "https://au.activationproducts.com/",
      "MN": "https://au.activationproducts.com/",
      "MM": "https://au.activationproducts.com/",
      "NP": "https://au.activationproducts.com/",
      "KP": "https://au.activationproducts.com/",
      "OM": "https://au.activationproducts.com/",
      "PK": "https://au.activationproducts.com/",
      "PS": "https://au.activationproducts.com/",
      "PH": "https://au.activationproducts.com/",
      "QA": "https://au.activationproducts.com/",
      "SA": "https://au.activationproducts.com/",
      "SG": "https://au.activationproducts.com/",
      "KR": "https://au.activationproducts.com/",
      "LK": "https://au.activationproducts.com/",
      "SY": "https://au.activationproducts.com/",
      "TW": "https://au.activationproducts.com/",
      "TJ": "https://au.activationproducts.com/",
      "TH": "https://au.activationproducts.com/",
      "TR": "https://au.activationproducts.com/",
      "TM": "https://au.activationproducts.com/",
      "AE": "https://au.activationproducts.com/",
      "UZ": "https://au.activationproducts.com/",
      "VN": "https://au.activationproducts.com/",
      "YE": "https://au.activationproducts.com/"
    };
    
    $.getJSON('/browsing_context_suggestions.json', function(data) {
      //var response_data = JSON.parse(data);
      console.log(data);
      console.log(data.detected_values.country);

      if ( ap_store_map.hasOwnProperty(data.detected_values.country.handle ) ) {
        
        let country = data.detected_values.country.name;
        
        if ( ap_store_map[ data.detected_values.country.handle ] !== window.location.hostname ) {
          
          console.log("Redirecting to: " + ap_store_map[ data.detected_values.country.handle ] );
        }
        
   		let geo_param = url_params.get('georedirect');
    
        if ( typeof geo_param !== "undefined" && geo_param == 1 ) {

            var popover = $('<div></div>')
                .addClass('geo-redirect-alert')
                .appendTo('.currency-picker--toolbar');

            var popover_container = $('<div></div>')
                .addClass('geo-redirect-container')
                .appendTo( popover );

            var close_button = $('<span></span>')
                .addClass('geo-redirect-close')
                .on('click', function(ev) {
                    $(this).hide();          
                })
                .appendTo( popover );

            var popover_header = $('<div></div>')
                .addClass('geo-redirect-header')
                .text("We noticed you're from " + country + "!")
                .appendTo( popover_container );

            var popover_content = $('<p></p>')
                .addClass('geo-redirect-body')
                .appendTo( popover_container );
        }
      }
    });
    

  })();
  
}